import angular from 'angular';
import uiRouter from 'angular-ui-router';
import reportComponent from './report.component';

let reportModule = angular.module('report', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise('/');

    $stateProvider
        .state('report', {
            url: '/report',
            resolve: {
              currentData: (LoadedModel) => {
                return LoadedModel.getCurrentSession();
              },
            },
            component: 'report'
        });
})

.component('report', reportComponent)

.name;




export default reportModule;



// WEBPACK FOOTER //
// ./client/app/components/report/report.js